import Swiper from 'swiper/bundle';

/**
* Updates the background image of the card container elements.
* @param {boolean} desktop - Indicates if the screen width is at least 768px
*/

function updateBackgroundImages(desktop) {
  const slides = document.querySelectorAll('.swiper-slide-home .card-container-banner-home');
  slides.forEach(slide => {
    const backgroundImageMobile = slide.style.getPropertyValue('--background-image-mobile');
    const backgroundImageDesktop = slide.style.getPropertyValue('--background-image-desktop');

    if (desktop) {
      slide.style.backgroundImage = backgroundImageDesktop;
    } else {
      slide.style.backgroundImage = backgroundImageMobile;
    }
  });
}

/**
 * Updates the font size, line height and padding left of the card information elements.
 * @param {boolean} desktop - Indicates if the screen width is at least 768px
 */

function updateElementStyles(desktop) {
  const properties = [
    { name: 'fontSize', desktop: 'data-desktop-font-size', mobile: 'data-mobile-font-size' },
    { name: 'lineHeight', desktop: 'data-desktop-line-height', mobile: 'data-mobile-line-height' },
    { name: 'paddingLeft', desktop: 'data-desktop-padding-left', mobile: null }
  ];
  const elements = document.querySelectorAll('.card-information, .card-information-text--title, .card-information-text--subtitle');
  elements.forEach(element => {
    properties.forEach(property => {
      const value = desktop ? element.getAttribute(property.desktop) : element.getAttribute(property.mobile);
      if (value) {
        element.style[property.name] = value;
      }
    });
  });
}

/**
 * Initializes the Swiper carousel for the product banners on the homepage.
 * @param {string} name - The class name of the Swiper container
 * @param {boolean} desktop - Indicates if the screen width is at least 768px
 * @returns {Swiper} - The Swiper instance
 */

function initSwiperHome(name, desktop) {
  const swiperProductCarouselHome = new Swiper(`.${name}`, {
    effect: 'fade',
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    fadeEffect: {
      crossFade: true
    },
    on: {
      slideChange: function () {
        updateBackgroundImages(desktop);
        updateElementStyles(desktop);
      }
    },
    pagination: {
      el: '.swiper-home-product-pagination',
    },
    navigation: {
      nextEl: '.swiper-home-product-button-next',
      prevEl: '.swiper-home-product-button-prev',
    },
  });

  return swiperProductCarouselHome;
}

export default function productCarouselHomepage() {
  const homeCarouselMainContainer = document.querySelector('.swiper-product-homepage');
  // If the main container is not present, exit the function
  if (!homeCarouselMainContainer) return;

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  initSwiperHome('swiper-product-homepage', isDesktop);
  updateBackgroundImages(isDesktop);
  updateElementStyles(isDesktop);
  window.addEventListener('resize', () => {
    updateBackgroundImages(isDesktop);
    updateElementStyles(isDesktop);
  });

}